import {
  FloatingFormItem,
  InputDecimal,
  InputText,
} from '@/components/_common';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Col, Form, Input, Row, Select, Typography } from 'antd';
import { FormInstance } from 'antd/es/form/Form';
import { useEffect } from 'react';

interface Props {
  form: FormInstance;
}

const NoteItensGeneralInfo = ({ form }: Props) => {
  const { Title } = Typography;

  const quantity = Form.useWatch('quantity', form);
  const valueUnitary = Form.useWatch('valueUnitary', form);
  const unconditionalDiscount = Form.useWatch('unconditionalDiscount', form);

  const defaultEmptyFieldError = useDefaultEmptyFieldError();

  useEffect(() => {
    const grossServiceValue = quantity * valueUnitary;

    form.setFieldValue('grossServiceValue', grossServiceValue ?? 0);
  }, [quantity, valueUnitary, unconditionalDiscount]);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <Title level={5}>Informações gerais</Title>
      </Col>

      <Col xs={24} md={12} xl={6}>
        <FloatingFormItem
          label="Descrição"
          name="description"
          rules={[defaultEmptyFieldError]}
        >
          <Input />
        </FloatingFormItem>
      </Col>

      <Col xs={24} md={12} xl={6}>
        <FloatingFormItem label="Quantidade" name="quantity" initialValue={0}>
          <InputText onlyNumber />
        </FloatingFormItem>
      </Col>

      <Col xs={24} md={12} xl={6}>
        <FloatingFormItem
          label="Unidade"
          name="unitMeasurement"
          rules={[defaultEmptyFieldError]}
        >
          <Input />
        </FloatingFormItem>
      </Col>

      <Col xs={24} md={12} xl={6}>
        <FloatingFormItem
          label="Preço unitário"
          name="valueUnitary"
          initialValue={0}
          rules={[defaultEmptyFieldError]}
        >
          <InputDecimal />
        </FloatingFormItem>
      </Col>

      <Col xs={24} md={12} xl={6}>
        <FloatingFormItem
          label="Responsável retenção"
          name={['itemTaxes', 'withholdingResponsible']}
        >
          <Select
            options={[
              {
                value: '1',
                label: 'Tomador',
              },
              {
                value: '2',
                label: 'Intermediário',
              },
            ]}
          />
        </FloatingFormItem>
      </Col>

      <Col xs={24} md={12} xl={6}>
        <FloatingFormItem
          label="Tributos federais retidos"
          name={['itemTaxes', 'federalTaxesWithheld']}
        >
          <Select
            options={[
              {
                value: 'true',
                label: 'Sim',
              },
              {
                value: 'false',
                label: 'Não',
              },
            ]}
          />
        </FloatingFormItem>
      </Col>

      <Col xs={24} md={12} xl={6}>
        <FloatingFormItem
          label="Desconto condicionado"
          name="conditionalDiscount"
        >
          <InputDecimal />
        </FloatingFormItem>
      </Col>

      <Col xs={24} md={12} xl={6}>
        <FloatingFormItem
          label="Desconto incondicionado"
          name={'unconditionalDiscount'}
        >
          <InputDecimal />
        </FloatingFormItem>
      </Col>
    </Row>
  );
};

export default NoteItensGeneralInfo;
